// Keep list title/breadcrumb in sync with index.ts (userSessionsResourceOptions).
export const userSessionsResourceOptions = {
  list: {
    title: 'User Sessions',
    breadCrumb: 'User Sessions',
  },
}

export default {
  list: { lazy: () => import('./UserSessionsListPage') },
  options: userSessionsResourceOptions,
}
